import { configureStore } from '@reduxjs/toolkit';

import authSlice from 'features/auth/auth.slice';
import usersSlice from 'features/users/users.slice';
import suppliersSlice from 'features/suppliers/suppliers.slice';
import inventoriesSlice from 'features/inventories/inventories.slice';
import marketplacesSlice from 'features/marketplaces/marketplaces.slice';
import storesSlice from 'features/stores/stores.slice';
import listingsSlice from 'features/listings/listings.slice';
import storeSynchronizationSlice from 'features/store-synchronization/store-synchronization.slice';
import thirdPartyIntegrationsSlice from 'features/third-party-integrations/third-party-integrations.slice';
import listingRepricerSlice from 'features/listing-repricer/listing-repricer.slice';
import listingOptimizerSlice from 'features/listing-optimizer/listing-optimizer.slice';
import listingCreationSlice from 'features/listing-creation/listing-creation.slice';
import skuManagementSlice from 'features/sku-management/sku-management.slice';
import ordersSlice from 'features/orders/orders.slice';
import appSettingsSlice from 'features/app-settings/app-settings.slice';

const store = configureStore({
  reducer: {
    auth: authSlice,
    users: usersSlice,
    suppliers: suppliersSlice,
    inventories: inventoriesSlice,
    marketplaces: marketplacesSlice,
    stores: storesSlice,
    listings: listingsSlice,
    storeSynchronization: storeSynchronizationSlice,
    thirdPartyIntegrations: thirdPartyIntegrationsSlice,
    listingRepricer: listingRepricerSlice,
    listingOptimizer: listingOptimizerSlice,
    listingCreation: listingCreationSlice,
    skuManagement: skuManagementSlice,
    orders: ordersSlice,
    appSettings: appSettingsSlice,
  },
});

export default store;
